import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _NotificationsNoneOut, _Box, _MoreVertIcon, _OpenNotifications;
import React, { useEffect, useRef, useState, useMemo } from 'react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { OpenNotifications } from '../../../icons/OpenNotifications';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { NotificationItem } from './NotificationItem';
import { useLocalization } from '@im/react-localization';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var NotificationDrop = function NotificationDrop(props) {
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    _dismiss = props.dismiss,
    markAllAsRead = props.markAllAsRead,
    _markAsReadItem = props.markAsReadItem,
    allNotifications = props.notifications,
    _onNotificationItemClick = props.onNotificationItemClick,
    openNotifications = props.openNotifications,
    _props$showWelcomeMsg = props.showWelcomeMsg,
    showWelcomeMsg = _props$showWelcomeMsg === void 0 ? false : _props$showWelcomeMsg,
    unReadCount = props.unReadCount;
  var _useState = useState(window.innerHeight - 64 < 670 ? window.innerHeight - 64 : 670),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var menuAnchorEl = useRef(null);
  var _useState5 = useState('all'),
    _useState6 = _slicedToArray(_useState5, 2),
    type = _useState6[0],
    setType = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showMenuPopover = _useState8[0],
    setShowMenuPopover = _useState8[1];
  var id = anchorEl ? 'notification-icon-button' : undefined;
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  var onClose = function onClose() {
    return setAnchorEl(null);
  };
  var notifications = useMemo(function () {
    return allNotifications.filter(function (item) {
      if (type === 'all') {
        return true;
      } else if (type === 'unread') {
        if (!item.isRead) {
          return true;
        }
      } else if (item.isRead) {
        return true;
      }
      return false;
    });
  }, [allNotifications, type]);
  useEffect(function () {
    if (unReadCount === 0) {
      setType('all');
    }
  }, [unReadCount]);
  useEffect(function () {
    var handleWindowResize = function handleWindowResize() {
      setMaxHeight(window.innerHeight - 64 < 670 ? window.innerHeight - 64 : 670);
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  var handleChangeType = function handleChangeType(_type) {
    setType(_type);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-describedby": id,
      className: "iconButton",
      "data-testid": "".concat(testid, "-NotificationBtn"),
      onClick: function onClick(e) {
        return setAnchorEl(anchorEl ? null : e.currentTarget);
      },
      sx: {
        marginLeft: '4px!important'
      },
      "data-element": "IconButton",
      "data-source-file": "NotificationDrop.tsx",
      children: /*#__PURE__*/_jsx(StyledBadge, {
        badgeContent: unReadCount,
        "data-element": "StyledBadge",
        "data-source-file": "NotificationDrop.tsx",
        children: _NotificationsNoneOut || (_NotificationsNoneOut = /*#__PURE__*/_jsx(NotificationsNoneOutlinedIcon, {
          "data-element": "NotificationsNoneOutlinedIcon",
          "data-source-file": "NotificationDrop.tsx"
        }))
      })
    }), /*#__PURE__*/_jsx(StylePopover, {
      anchorEl: anchorEl,
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      anchorReference: "anchorEl",
      id: id,
      onClose: onClose,
      open: !!anchorEl,
      sx: {
        '& .MuiPopover-paper': {
          maxHeight: maxHeight
        }
      },
      transformOrigin: {
        horizontal: 'right',
        vertical: 'top'
      },
      "data-element": "StylePopover",
      "data-source-file": "NotificationDrop.tsx",
      children: /*#__PURE__*/_jsxs(Paper, {
        sx: {
          overflow: 'hidden'
        },
        "data-element": "Paper",
        "data-source-file": "NotificationDrop.tsx",
        children: [/*#__PURE__*/_jsx(Stack, {
          alignItems: "center",
          direction: "row",
          justifyContent: "space-between",
          pl: 2,
          py: 1,
          spacing: 2,
          "data-element": "Stack",
          "data-source-file": "NotificationDrop.tsx",
          children: /*#__PURE__*/_jsxs(Stack, {
            width: '100%',
            "data-element": "Stack",
            "data-source-file": "NotificationDrop.tsx",
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "bodycopyregular",
              "data-element": "Typography",
              "data-source-file": "NotificationDrop.tsx",
              children: translate('X4CNotifications.Notifications')
            }), /*#__PURE__*/_jsxs(Stack, {
              direction: "row",
              gap: 1,
              mt: 1,
              "data-element": "Stack",
              "data-source-file": "NotificationDrop.tsx",
              children: [/*#__PURE__*/_jsx(Chip, {
                "data-name": "All_Notifications",
                label: translate('X4CNotifications.All'),
                onClick: function onClick() {
                  handleChangeType('all');
                },
                sx: {
                  '.MuiChip-label': {
                    color: type === 'all' ? '#0164B0 !important' : '#333'
                  },
                  background: type === 'all' ? '#F3FAFF' : '#fff',
                  borderColor: type === 'all' ? '#0077D4' : '#C4C4C4'
                },
                variant: type === 'all' ? 'filled' : 'outlined',
                "data-element": "Chip",
                "data-source-file": "NotificationDrop.tsx"
              }), /*#__PURE__*/_jsx(Chip, {
                "data-name": "Unread_Notifications",
                label: translate('X4CNotifications.Unread'),
                onClick: function onClick() {
                  handleChangeType('unread');
                },
                sx: {
                  '.MuiChip-label': {
                    color: type === 'unread' ? '#0164B0 !important' : '#333'
                  },
                  background: type === 'unread' ? '#F3FAFF' : '#fff',
                  borderColor: type === 'unread' ? '#0077D4' : '#C4C4C4'
                },
                variant: type === 'unread' ? 'filled' : 'outlined',
                "data-element": "Chip",
                "data-source-file": "NotificationDrop.tsx"
              }), _Box || (_Box = /*#__PURE__*/_jsx(Box, {
                flex: 1,
                "data-element": "Box",
                "data-source-file": "NotificationDrop.tsx"
              })), /*#__PURE__*/_jsx(Link, {
                onClick: markAllAsRead,
                sx: {
                  fontWeight: 400
                },
                variant: "link",
                "data-element": "Link",
                "data-source-file": "NotificationDrop.tsx",
                children: translate('X4CNotifications.MarkAllAsRead')
              }), /*#__PURE__*/_jsx(IconButton, {
                "data-name": "Notifi_MoreVertIcon",
                onClick: function onClick() {
                  return setShowMenuPopover(true);
                },
                ref: menuAnchorEl,
                sx: {
                  visibility: 'hidden'
                },
                "data-element": "IconButton",
                "data-source-file": "NotificationDrop.tsx",
                children: _MoreVertIcon || (_MoreVertIcon = /*#__PURE__*/_jsx(MoreVertIcon, {
                  "data-element": "MoreVertIcon",
                  "data-source-file": "NotificationDrop.tsx"
                }))
              }), /*#__PURE__*/_jsx(StylePopover, {
                anchorEl: menuAnchorEl.current,
                anchorOrigin: {
                  horizontal: 'right',
                  vertical: 'top'
                },
                anchorReference: "anchorEl",
                id: id,
                onClose: function onClose() {
                  return setShowMenuPopover(false);
                },
                open: showMenuPopover,
                sx: {
                  '& .MuiPopover-paper': {
                    maxHeight: maxHeight
                  }
                },
                transformOrigin: {
                  horizontal: 'right',
                  vertical: 'top'
                },
                "data-element": "StylePopover",
                "data-source-file": "NotificationDrop.tsx",
                children: /*#__PURE__*/_jsx(Paper, {
                  "data-element": "Paper",
                  "data-source-file": "NotificationDrop.tsx",
                  children: /*#__PURE__*/_jsxs(MenuItem, {
                    "data-name": "Notifi_OpenMessageCenter",
                    onClick: function onClick() {
                      setShowMenuPopover(false);
                      // onClose();
                      openNotifications();
                    },
                    "data-element": "MenuItem",
                    "data-source-file": "NotificationDrop.tsx",
                    children: [/*#__PURE__*/_jsx(ListItemIcon, {
                      sx: {
                        ml: '29px'
                      },
                      "data-element": "ListItemIcon",
                      "data-source-file": "NotificationDrop.tsx",
                      children: _OpenNotifications || (_OpenNotifications = /*#__PURE__*/_jsx(OpenNotifications, {
                        "data-element": "OpenNotifications",
                        "data-source-file": "NotificationDrop.tsx"
                      }))
                    }), /*#__PURE__*/_jsx(ListItemText, {
                      sx: {
                        ml: '20px'
                      },
                      "data-element": "ListItemText",
                      "data-source-file": "NotificationDrop.tsx",
                      children: /*#__PURE__*/_jsx(Typography, {
                        color: "#000000",
                        fontSize: 16,
                        variant: "bodycopyregular",
                        "data-element": "Typography",
                        "data-source-file": "NotificationDrop.tsx",
                        children: translate('X4CNotifications.OpenNotifications')
                      })
                    })]
                  })
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(ScrollArea, {
          style: {
            maxHeight: '100%',
            overflowY: 'scroll'
          },
          "data-element": "ScrollArea",
          "data-source-file": "NotificationDrop.tsx",
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              maxHeight: maxHeight - 86
            },
            "data-element": "Box",
            "data-source-file": "NotificationDrop.tsx",
            children: notifications.length > 0 ? notifications.map(function (item) {
              return /*#__PURE__*/_jsx(NotificationItem, {
                dismiss: function dismiss() {
                  _dismiss(item);
                },
                item: item,
                //markAsRead={() => markAsRead(item.messageId)}
                markAsReadItem: function markAsReadItem() {
                  _markAsReadItem(item);
                },
                onNotificationItemClick: function onNotificationItemClick() {
                  _onNotificationItemClick(item);
                },
                showWelcomeMsg: showWelcomeMsg
              }, item.messageId);
            }) : /*#__PURE__*/_jsx(Typography, {
              fontSize: 14,
              p: 2,
              children: translate('X4CNotifications.NoNotificationsAvailable')
            })
          })
        })]
      })
    })]
  });
};
var StyledBadge = styled(Badge)(function () {
  return {
    '& .MuiBadge-badge': {
      backgroundColor: '#B11616',
      transform: 'translate(4px, -7px)'
    }
  };
});
var StylePopover = styled(Popover)(function () {
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiOutlinedInput-root': {
      fontSize: 14,
      height: 24,
      textAlign: 'right',
      width: 96
    },
    '& .MuiPaper-root': {
      boxShadow: 'none'
    },
    '& .MuiPopover-paper': {
      borderRadius: 4,
      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 5px',
      width: 440
    }
  };
});
var ScrollArea = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[300],
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '1px',
      boxShadow: 'none'
    },
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
  };
});